import { Box, type SxProps } from '@mui/material';
import Grid from '@mui/material/Grid';

import useWindowSize from '/@/utils/hooks/window-size';
import styles from './styles.module.css';

const ReferenceBar = ({
    sx,
    references,
    crop,
}: {
    sx?: SxProps;
    references: { text: string; color: string }[];
    crop: string;
}) => {
    const { width } = useWindowSize();
    const isMobile = width < 750;
    if (crop !== 'corn') return null;
    return (
        <Box sx={{ ...sx }}>
            <Grid
                container
                sx={{
                    border: '0.5px solid #C9C9C9',
                    borderRadius: '20px',

                    p: 0.5,
                    px: 1,
                    maxWidth: '700px',
                    fontSize: (t) => t.typography.caption.fontSize,
                }}
                alignItems='center'
            >
                {references.map((r, i) => {
                    return (
                        <Grid item key={i}>
                            <Grid container justifyContent='center' alignItems='center' sx={{ flexWrap: 'nowrap' }}>
                                <Grid item sx={{ m: 1, mx: isMobile ? 0.5 : undefined }}>
                                    <span className={styles.dot} style={{ backgroundColor: r.color }} />
                                </Grid>
                                <Grid item sx={{ m: 1, mx: isMobile ? 0.5 : undefined }}>
                                    {r.text}
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default ReferenceBar;
